import styled from "styled-components";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

/** Shared landing page shell — prevents horizontal overflow on `/home` */
export const LandingPageRoot = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const SectionContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  ${media.downTablet`
    width: 100%;
  `}
`;
